import { MART_PRODUCT_STATE_KEY, MartProductState } from './martProduct-reducer';

export enum MART_PRODUCT_ACTION_TYPE {
  SET_MART_PRODUCT_STATE = 'SET_MART_PRODUCT_STATE',
  CALL_MART_PRODUCT_TNC = 'CALL_MART_PRODUCT_TNC',

}

export type SetMartProductStateAction<KeyName extends keyof MartProductState> = {
  type: MART_PRODUCT_ACTION_TYPE.SET_MART_PRODUCT_STATE;
  payload: { key: KeyName, value: MartProductState[KeyName] };
};

export type CallMartProductTncAction = {
  type: MART_PRODUCT_ACTION_TYPE.CALL_MART_PRODUCT_TNC;
  payload: { data: any, isCallTnc: boolean }
};

export type MartProductActions = SetMartProductStateAction<MART_PRODUCT_STATE_KEY> | CallMartProductTncAction;
